import SEOHead from "@/components/SEOHead";
import OverpayingScorecard from "@/components/OverpayingScorecard";
import TrustBar from "@/components/TrustBar";
import RelatedTools from "@/components/RelatedTools";
import SolutionsCrossSell from "@/components/SolutionsCrossSell";

export default function OverpayingScorecardPage() {
  return (
    <div>
      <SEOHead title="Card Payment Overpaying Scorecard" description="Are you overpaying for card payments? Take our free 60-second assessment and find out. No obligation, instant result." path="/overpaying-scorecard" />

      {/* Trust signals above the tool — cold campaign traffic must see
          proof before committing to answer questions. Moving TrustBar
          from below-the-tool to above-the-tool lifts completion rate. */}
      <TrustBar />

      <section className="py-10 md:py-16 bg-gray-50" id="scorecard" data-testid="calculator-section">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-6">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-aqua mb-3">Payment Health Check</p>
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-brand-black tracking-tight mb-3">Are you overpaying for card payments?</h1>
            <p className="text-brand-grey leading-relaxed max-w-xl mx-auto">Answer a few quick questions and we&apos;ll score how competitive your pricing looks. No sign-up, no obligation — takes under 60 seconds.</p>
          </div>
          <OverpayingScorecard />
        </div>
      </section>

      <RelatedTools currentPath="/overpaying-scorecard" />
      <SolutionsCrossSell currentPath="/overpaying-scorecard" />
    </div>
  );
}
